import { type CustomFieldValueData } from '@/common/types/fields'

export type CompanyDetailsDTOV1 = {
  id: number
  name?: string
  address?: string
  zipCode?: string
  city?: string
  country?: string
  externalRef?: string
  phone1?: string
  phone2?: string
  email1?: string
  email2?: string
  // expand CUSTOM_FIELDS
  customFields?: CustomFieldValueData[]
}

export enum CompanyExpandEnum {
  CUSTOM_FIELDS = 'CUSTOM_FIELDS',
}

export type CompanyFieldConfig = {
  expands?: Set<CompanyExpandEnum>
}

export type Company = CompanyDetailsDTOV1 & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}
